import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import {
  memberCreditDebitList,
  exportCreditDebitList,
} from "app/services/memberService";
import _ from "lodash";
import { MdSearch } from "react-icons/md";
import { AiOutlineCopy } from "react-icons/ai";
import { AiFillFileExcel } from "react-icons/ai";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import config from "config.json";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { useState } from "react";
import { useEffect } from "react";
import queryStringService from "app/services/queryStringService";
import AHandyScroll from "app/common/Scroll";
import HandyScroll from "app/common/Scroll";

const { dateTimeFormat } = config;

function MemberCreditDebitList() {
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    FromDate: "",
    ToDate: "",
    TransactionMode: "",
    SearchbyUser: "",
  });

  useEffect(() => {
    loadCRDRLog();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    state.page,
    state.sizePerPage,
    state.FromDate,
    state.ToDate,
    state.TransactionMode,
    state.SearchbyUser,
  ]);

  const dateFormatter = (cell, row) => {
    if (cell) {
      return moment(cell).format(dateTimeFormat);
    }
  };

  const tooltipFormatter = (cell, row) => {
    return (
      cell && (
        <Tooltip
          placement="top"
          overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
        >
          <span style={{ whiteSpace: "nowrap" }}>
            {cell.substring(0, 10)}...
            <AiOutlineCopy
              className="ms-1"
              onClick={async () => {
                if ("clipboard" in navigator) {
                  await navigator.clipboard.writeText(cell);
                  NotificationManager.success(
                    "Copied successfully ",
                    "Success",
                    5000
                  );
                }
              }}
            />
          </span>
        </Tooltip>
      )
    );
  };
  const balanceFormatter = (cell, row) => {
    return (
      <>
        <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>
      </>
    );
  };
  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.userRemark}</div>}
      >
        <span> {row.userRemark.substring(0, 10)}...</span>
      </Tooltip>
    );
  };

  const columns = [
    {
      dataField: "sln",
      text: "Sln",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return {
          width: "120px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "member.memberFullName",
      text: "Name",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "correlationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },
    {
      dataField: "transactionType",
      text: "Transaction Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionDate",
      text: "Transaction Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "trDoneBy",
      text: "Tran Done By",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "trApproveBy",
      text: "Tran ApproveBy",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "trAgainst",
      text: "Tran Against",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "refNo",
      text: "Ref No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },
    {
      dataField: "trWallet",
      text: "Tran Wallet",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "opening",
      text: "Opening",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "closing",
      text: "Closing",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "leadgerBalance",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "creditBalance",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "userRemark",
      text: "Remark",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    const { loading } = state;
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadCRDRLog = async (pageParam, sizePerPageParam) => {
    let {
      page,
      sizePerPage,
      FromDate,
      ToDate,
      isRefreshed,
      TransactionMode,
      SearchbyUser,
    } = state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: pageParam ? pageParam : page,
      pageSize: sizePerPageParam ? sizePerPageParam : sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
      SearchbyUser,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await memberCreditDebitList(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prevState) => ({
      ...prevState,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
      isRefreshed: false,
    }));
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    await loadCRDRLog(page, sizePerPage);
  };

  const handleSearch = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));
    setTimeout(async () => {
      await loadCRDRLog();
    }, 10);
  };

  const handleExport = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await exportAllLedger();
    }, 10);
  };

  const exportAllLedger = async () => {
    const {
      page,
      sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
      SearchbyUser,
    } = state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
      SearchbyUser,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await exportCreditDebitList(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_crdrList.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
  };

  const handleSearchChanges = (e) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const refreshFilter = async (e) => {
    setState((prevState) => ({
      ...prevState,
      FromDate: "",
      ToDate: "",

      // isRefreshed: true,
      TransactionMode: "",
      SearchbyUser: "",
    }));
  };

  // useEffect(() => {
  //   if (state.isRefreshed) {
  //     loadCRDRLog();
  //   }
  // }, [state.isRefreshed]);

  const {
    data,
    sizePerPage,
    page,
    dataCount,
    loading,
    FromDate,
    ToDate,
    TransactionMode,
    SearchbyUser,
  } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Member Credit Debit List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Member Credit Debit List" }]}
      ></Breadcrumb>

      <div className="card card-body">
        <div className="row mb-2">
          <div className="col-md-2">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              value={FromDate}
              onChange={handleSearchChanges}
            />
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              value={ToDate}
              onChange={handleSearchChanges}
            />
          </div>

          <div className="col-md-2">
            <div className="form-group">
              <label> Trans Mode</label>
            </div>
            <select
              className="form-control"
              name="TransactionMode"
              value={TransactionMode}
              onChange={handleSearchChanges}
            >
              <option value="Manual Credit"> Credit</option>
              <option value="Manual Debit"> Debit</option>
            </select>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label> Search User Name</label>
            </div>
            <input
              type="text"
              className="form-control"
              name="SearchbyUser"
              value={SearchbyUser}
              onChange={handleSearchChanges}
            />
          </div>
          <div
            className="col d-flex justify-content-center"
            style={{ marginTop: "36px" }}
          >
            <button
              className="btn btn-outline-primary  d-flex align-items-center"
              onClick={handleSearch}
            >
              <MdSearch className="" size={18} />
            </button>

            <button
              className="btn btn-primary d-flex align-items-center mx-1"
              onClick={refreshFilter}
            >
              Refresh
            </button>
            <Button
              variant="btn btn-outline-primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
              Export
              <AiFillFileExcel className="ms-1" />
            </Button>
          </div>
        </div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="sln"
              data={data}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              loading={loading}
              // overlay={overlayFactory({
              //   spinner: true,
              //   styles: {
              //     overlay: (base) => ({
              //       ...base,
              //       background: "rgba(120, 120, 120, 0.5)",
              //       zIndex: "1",
              //     }),
              //   },
              // })}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
}

export default MemberCreditDebitList;
